export const stringFunctions = {
    methods: {
        trunkateString(text) {
            var maxLength = 130,
                parsedText = this.removeHtml(text);

            return parsedText.length > maxLength ? parsedText.substring(0, maxLength) + '...' : parsedText;
        },
        removeHtml(text) {
            //return text
            return new DOMParser().parseFromString(text, 'text/html').body.textContent
        }
    }
}